import React, {useEffect, useState} from "react";
import {
    Input,
    Button,
    Typography,
    Checkbox, Tooltip
} from "@material-tailwind/react";
import axios from "axios";
import {useNavigate, useLocation, Link} from "react-router-dom";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";

export default function LoginForm() {

    const [email, setEmail] = useState("");
    const [lozinka, setLozinka] = useState("");
    const [loginError, setLoginError] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        try {
            const API_URL = process.env.REACT_APP_API_URL;  // koristi varijablu iz .env fajla

            const response = await axios.post(`${API_URL}/auth/login`, {
                email,
                lozinka
            });

            const token = response.data.token;
            localStorage.setItem("token", token);

            if (location.state && location.state.from) {
                navigate(location.state.from);
            } else {
                navigate("/home");
            }
        } catch (err) {
            setLoginError(true);
        }
    };

    useEffect(() => {
        setLoginError(false);
    }, [email, lozinka]);

    const TooltipLoginError = () => {
        return (
            <div className="p-1">
                <p className=" text-red-500 font-bold">Neispravan email ili lozinka</p>
            </div>
        );
    };

    function storeScrollPosition() {
        sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    }

    return (
        <div className="flex flex-col items-center justify-center w-full px-6 py-4 sm:px-8 sm:py-6">
            <Typography variant="h4" color="blue-gray" className="text-center mb-4 font-semibold">
                Prijavite se
            </Typography>

            <form className="mt-6 mb-2 w-full sm:max-w-md" onSubmit={handleLoginSubmit}>
                <div className="mb-4 flex flex-col gap-6">
                    <Input
                        color="blue"
                        size="lg"
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        error={loginError}
                        className="rounded-lg border-2"
                    />
                    <Input
                        color="blue"
                        type="password"
                        size="lg"
                        label="Lozinka"
                        value={lozinka}
                        onChange={(e) => setLozinka(e.target.value)}
                        error={loginError}
                        className="rounded-lg border-2"
                        icon={
                            loginError && (
                                <Tooltip content={<TooltipLoginError />} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                                    <ExclamationCircleIcon className="text-red-500 h-5 w-5" />
                                </Tooltip>
                            )
                        }
                    />
                </div>

                {/* Login Button */}
                <Button
                    color="green"
                    className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-12 sm:mt-16"
                    fullWidth
                    type="submit"
                    onClick={storeScrollPosition}
                >
                    Prijavite se
                </Button>

                <Typography color="gray" className="mt-4 text-center font-normal">
                    Zaboravili ste lozinku?{" "}
                    <Link to="/zaboravljena_lozinka">
                        <span className="font-medium text-gray-900">
                            Povrati nalog
                        </span>
                    </Link>
                </Typography>
            </form>
        </div>
    );
}